export default "__VITE_ASSET__338ea455__"